export default {
  title01: "Tempo Atual",
  title02: "24 Horas",
  title03: "Ver Previsão do Tempo para 10 Dias",
  title04: "AQI",
  title05: "Ver Toda a Informação",
  title06: "NASCIMENTO E PÔR DO SOL",
  title07: "FASES DA LUA",
  title08: "A Próxima Lua Cheia",
  title09: "A Próxima Lua Nova",
  title10: "DIA",
  title11: "NOITE",
  title12: "Nascer do Sol",
  title13: "Pôr do Sol",
  title14: "Nascer da Lua",
  title15: "Pôr da Lua",
  title16: "Fonte",
  title17: "Início",
  title18: "Fim",
  title19: "Usar Localização Atual",
  title20: "Pesquisar a Cidade",
  title21: "Sensação Térmica",
  title22: "Sensação Térmica à Sombra",
  title23: "Agora",
  title24: "Hoje",
  title25: "SOL",
  title26: "SEG",
  title27: "TER",
  title28: "QUA",
  title29: "QUI",
  title30: "SEX",
  title31: "SÁB",
  title32: "A Carregar...",
  title33: "Agora",
  title34: "Horário",
  title35: "Diário",
  title36: "Sol e Lua",
  title37: "Qualidade do Ar",
  title38: "Contacte: xlf550402@gmail.com",
  title39: "Acordo de Privacidade",
  title40: "Direitos de autor © comfortweather.com 2020 - 2025. Todos os Direitos Reservados.",
  title41: "Dados fornecidos por",
  title42: "Max",
  title43: "Min",
  title44: "Aceitar",
  title45:
    "Obrigado por utilizar o ComfortWeather! Para melhor proteger os seus direitos e interesses legais, leia atentamente a ",
  title46: "Política de Privacidade",
  title47: " antes de utilizar.",
  title48: "",
  title49: "Contacte: xyjph123@gmail.com",
  title50: "Direitos de autor © 24hweather.com 2020 - 2025. Todos os Direitos Reservados.",
  title51:
    "Obrigado por utilizar o 24hweather! Para melhor proteger os seus direitos e interesses legais, leia atentamente a ",
};
